import React, { useState } from "react";
import { connect } from 'react-redux';
import { store } from './../../effects/store'
import { updateCurrentSong, updateMuted } from './../../effects/actions'
import { ASSETS_FOLDER } from "../../assets";

export const setAudioMuted = (conditition = false) => store.dispatch(updateMuted(conditition))
export const getCurrentSong = () => store.getState().app.currentSong

const songsFactoryFinishing1 = ["0006_FabricaInterior.mp3", "432491.mp3", "405063.mp3", "405062.mp3", "405061.mp3", "405060.mp3", "367169.mp3", "0007_FabricaInterior_02.mp3"];
const songsFactoryFinishing2 = ["0004_FabricaInterior_02.mp3", "2745544_Fabrica_Interior_Finishing2.mp3", "2745543_Fabrica_Interior_Finishing2.mp3", "274547_Finishing2.mp3", "274546_Finishing2.mp3", "0005_FabricaInterior_02.mp3"];
const songsFactoryComponents = ["0001_FabricaInterior_02.mp3", "0002_FabricaInterior_02.mp3", "0003_FabricaInterior_1.mp3", "136620__herbertboland__industrialcomplex4.mp3", "519026__kinoton__industrial-ambience-package-centre.mp3"];
const songsOutside = ["102030.mp3","160226.mp3"];
const songsDrone = ["160226.mp3", "188402.mp3", "102030.mp3"];



const SoundPlayerComponent = ({ muted, type, currentSong, currentPanorama }) => {
  const [src, setSrc] = useState("")
  const audioRef = React.useRef()

  const getActRandomSound = (type) => {
    switch (type) {
      case 'factory-2':
        return `finishing-2/` + songsFactoryFinishing2[Math.floor(Math.random() * songsFactoryFinishing2.length)]
      case 'factory-1':
        return `components/` + songsFactoryComponents[Math.floor(Math.random() * songsFactoryComponents.length)]
      case 'outside':
        return `outside/` + songsOutside[Math.floor(Math.random() * songsOutside.length)]
      case 'drone':
        return `arl/` + songsDrone[Math.floor(Math.random() * songsDrone.length)]
      default:
        return `finishing-1/` + songsFactoryFinishing1[Math.floor(Math.random() * songsFactoryFinishing1.length)]
    }
  }


  React.useEffect(() => {
    let randomSound = getActRandomSound(type)
    const soungSource = randomSound
    const src = `${ASSETS_FOLDER}/sounds/${soungSource}`
    setSrc(src)
    if (!audioRef.current) return;
    if (!window.audioRef) window.audioRef = audioRef.current
    
    audioRef.current.muted = muted;
    audioRef.current.src = src;
    audioRef.current.volume = type === "showroom" ? 0 : 0.4;
  }, [muted, currentSong, type, currentPanorama])
  return <audio ref={audioRef} autoPlay muted={muted} loop src={src} />
};
const mapStateToProps = ({ app }) => {
  const { currentSong, muted } = app
  return { currentSong, muted }
}

export default connect(mapStateToProps, { updateCurrentSong, updateMuted })(React.memo(SoundPlayerComponent));